<template>
  <div class="component component--login">
      <div class="login">
        <loader v-if="loading"/>
          <div class="login__logo">
              <img src="../assets/images/media.png" alt="Logo MediaMarkt" />
          </div>
          <form @submit.prevent="loginAction">
            <div class="form-group login-input" :class="[{ 'input-error': $v.login.$error || badLogin && !$v.password.required}, { 'input-success': $v.login.email && login != '' && !badLogin}]">
              <label>E-mail</label>
              <input type="text" v-model="login" name="login" class="form-control form-control-lg" @keyup.enter="cursor()" @change="$v.$touch()">
              <labelInfo v-if="$v.login.email && login != '' && !badLogin" :display="true"/>
              <labelInfo v-if="!$v.login.required" type="error" message="To pole jest wymagane"/>
              <labelInfo v-if="!$v.login.email" type="error" message="Nieprawidłowe dane"/>
              <labelInfo v-if="!$v.password.required && badLogin" type="error" message="Nieprawidłowe dane"/>
              <labelInfo v-if="!$v.password.required && inActive" type="error" message="Twoje konto zostało zablokowane."/>
            </div>
            <div class="form-group login-input" :class="{ 'input-error': $v.password.$error }">
              <label>Hasło</label>
              <input type="password" v-model="password" name="password" class="form-control form-control-lg">
              <labelInfo v-if="!$v.password.required" type="error" message="To pole jest wymagane"/>
              <labelInfo v-if="!$v.password.required && badLogin" type="error" message="Nieprawidłowe dane"/>
            </div>
            <div class="form-group">
              <button class="button-normal button-normal--login">Zaloguj się</button>
            </div>
          </form>
      </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import labelInfo from '@/components/blocks/labelInfo.vue'
import loader from '@/components/blocks/loader.vue'

export default {

  name: 'Login',
  components:{

    labelInfo,
    loader,

  },
  mixins: [validationMixin],
  data () {

    return {

      login: '',
      password: '',
      badLogin: false,
      inActive: false,

      loading: false,

    }

  },
  validations: {

    login: {

      required,
      email

    },
    password: {

      required

    }
  },
  methods: {

    loginAction(){

      this.$v.$touch();

      if(!this.$v.$invalid){

        this.loading = true;

        let data = {
          'username': this.login,
          'password': this.password
        }

        this.$http.post('login_check', data).then(response => {

          this.badLogin = false;

          localStorage.setItem('auth_token', response.data.token);
          localStorage.setItem('refresh_token', response.data.refresh_token);

          if (localStorage.getItem('auth_token') != null){

            let user = JSON.stringify(response.data.data.user);
            let role = response.data.data.user.roles[0];
            this.clearStorage('sessionTimer');

            localStorage.setItem('user', user);
            localStorage.setItem('role', role);

            this.$parent.getUserRole();

            if(this.$route.params.nextUrl == null){

              this.$router.push('dashboard');

            }

          }

        }).catch(error => {

          if(error.response.status === 400 || error.response.status === 401 || error.response.status === 402) {
            
            this.password = '';           
            this.badLogin = true;
            this.loading = false;

            if(error.response.data.message == 'User account is disabled.'){

              this.inActive = true;

            }

          }else{

            console.error(error.response);
            this.loading = false;

          }

        })
      
      }

    },

    cursor(){

      if(document.getElementsByName("password")[0].value == ""){

        document.getElementsByName("password")[0].select();

      }

    },

  },
  
};
</script>

<style lang="scss" scoped>

.component--login{
  display:flex;
  position: absolute;
  width:100%;
  height:100%;
  justify-content: center;
  align-items: center;
}

form{
  width:95%;
}

.login{
  position:relative;
  display:flex;
  flex-direction: column;
  align-items: center;
  width:642px;
  height:425px;
  background:#fff;
  box-sizing: border-box;
  padding: 20px;
  border: 1px #e3000b solid;

  &__logo{
    display:flex;
    justify-content: center;
    width:100%;
    padding:40px 0px;
  }
}

</style>
